/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для блока контрагента в личном кабинете.
   */
  app.CounterpartyView = app.View.extend({

    // Обработчики пользовательских событий
    events: {
      'click [data-counterparty-id] .remove-counterparty': 'confirmRemoveCounterparty'
    },

    run: function (options) {
      this.owner = options.owner;
      this.counterparties = this.owner.counterparties;
    },

    /**
     * Запрос подтверждения удаления контрагента в личном кабинете.
     * @param {object} e Events.
     */
    confirmRemoveCounterparty: function (e) {
      this.counterpartyId = $(e.currentTarget).parent().data('counterparty-id');

      this.counterparty = this.counterparties.get(this.counterpartyId);
      this.counterparty.set('is_delete', true);
    }
  });
})(jQuery);

}.call(window));